export const truncateText = (text, maxLength = 60) => {
  if (typeof text !== "string") {
    return "";
  }
  return text.length > maxLength ? text.slice(0, maxLength - 3) + "..." : text;
};

export const getTruncatedStringFromArray = (array, index, t, maxLength = 60) => {
  // Add (+n others) if text exceeds maxLength
  // Process only for the first index of the array (which can be truncated too!)
  if (index !== 0 || !Array.isArray(array) || array.length === 0) {
    return "";
  }
  const displayedValues = [];
  let currentLength = 0;
  let remainingCount = 0;

  // Calculate the "other" text for remaining items
  const getRemainingText = (count) => {
    if (count === 0) return "";
    return ` (+${count} ${count === 1 ? t("other") : t("others")})`;
  };

  const manageFirstValue = (value, otherText) => {
    const maxFirstValueLength = maxLength - otherText.length;
    if (value.length + otherText.length > maxLength) {
      const truncatedValue = value.slice(0, maxFirstValueLength - 3) + "...";
      displayedValues.push(truncatedValue);
      currentLength = truncatedValue.length;
      remainingCount = array.length - 1;
    } else {
      displayedValues.push(value);
      currentLength = value.length;
    }
  };

  for (let i = 0; i < array.length; i++) {
    const value = array[i];
    const separator = i > 0 ? ", " : "";
    const remaining = array.length - i - 1;
    const otherText = getRemainingText(remaining);
    if (i === 0) {
      manageFirstValue(value, otherText);
    } else {
      const valueWithSeparator = separator + value;
      const totalLengthWithValue = currentLength + valueWithSeparator.length;
      const totalLengthNeeded = totalLengthWithValue + otherText.length;

      if (totalLengthNeeded > maxLength) {
        remainingCount = array.length - i;
        break;
      }

      displayedValues.push(value);
      currentLength = totalLengthWithValue;
    }
  }

  let label = displayedValues.join(", ");

  if (remainingCount > 0) {
    label += ` (+${remainingCount} ${remainingCount === 1 ? t("other") : t("others")})`;
  }

  return label;
};

// The audit-ppp-back SDK reads null as undefined, which pinia-orm would replace with the field default.
export const undefinedToNull = (value) => {
  if (value === undefined) return null;
  if (Array.isArray(value)) return value.map(undefinedToNull);
  if (value && typeof value === "object" && !(value instanceof Date)) {
    return Object.fromEntries(
      Object.entries(value).map(([key, item]) => [key, undefinedToNull(item)]),
    );
  }
  return value;
};
